import {
  TextField,
  InlineStack,
  BlockStack,
  Button,
  Layout,
  LegacyCard,
} from "@shopify/polaris";
import { useState, useEffect } from "react";

import storageUtils from "../utils/storageUtils";
import { g_setting_info, c_u_setting_info } from "../api";

export default function CheckoutSettings() {
  const [loading, setLoading] = useState(false);
  const [checkout_data, setCheckoutData] = useState({});
  const user_token = storageUtils.get("user_token");

  const querySettings = async () => {
    try {
      const params = {
        user_token: user_token,
      };
      const response = await g_setting_info(params);
      if (!response.data) return;
      setCheckoutData(response.data);
    } catch (error) {}
  };
  const saveCheckoutSettings = async () => {
    try {
      const params = {
        user_token: user_token,
        checkout_data: checkout_data,
      };
      setLoading(true);
      await c_u_setting_info(params);
      setLoading(false);
      querySettings();
    } catch (error) {}
  };
  useEffect(() => {
    querySettings();
  }, []);

  const handleCheckoutData = (key, value) => {
    setCheckoutData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Layout>
      <Layout.AnnotatedSection
        title="Checkout Setting"
        description="The logo on the checkout page, the terms of service, the default country, and other content settings related to the checkout page"
      >
        <LegacyCard sectioned>
          <BlockStack gap="100">
            {checkout_data.logo_url ? (
              <img
                src={checkout_data.logo_url}
                alt="Logo"
                width={160}
                height={"auto"}
              ></img>
            ) : null}
            <TextField
              value={checkout_data.logo_url}
              onChange={(value) => handleCheckoutData("logo_url", value)}
              label="Logo Url"
            />
            <TextField
              value={checkout_data.default_country}
              onChange={(value) => handleCheckoutData("default_country", value)}
              label="Default country settings (country code)"
            />
            <TextField
              value={checkout_data.rp}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("rp", value)}
              label="Refund policy"
            />
            <TextField
              value={checkout_data.sp}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("sp", value)}
              label="Shipping policy"
            />
            <TextField
              value={checkout_data.pp}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("pp", value)}
              label="Privacy policy"
            />
            <TextField
              value={checkout_data.tos}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("tos", value)}
              label="Terms of service"
            />
            <TextField
              value={checkout_data.co}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("co", value)}
              label="Contact"
            />
            <TextField
              value={checkout_data.promise}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("promise", value)}
              label="Checkout page promise"
            />
            <TextField
              value={checkout_data.header_code}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("header_code", value)}
              label="Checkout page header code"
            />
            <TextField
              value={checkout_data.header_js_code}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("header_js_code", value)}
              label="JavaScript at the page header"
            />
            <TextField
              value={checkout_data.footer_js_code}
              multiline={1}
              maxHeight="240px"
              onChange={(value) => handleCheckoutData("bottom_js_code", value)}
              label="JavaScript at the page bottom"
            />
            <InlineStack align="end">
              <Button
                loading={loading}
                submit
                onClick={() => {
                  saveCheckoutSettings();
                }}
              >
                Save
              </Button>
            </InlineStack>
          </BlockStack>
        </LegacyCard>
      </Layout.AnnotatedSection>
    </Layout>
  );
}
